import React from "react";

const Logo = () => {
    return (
        <div className="logo">
            <div>
                <a href="/" className="logo" title="Xổ số Minh Ngọc™ Kết Quả Xổ Số Trực Tiếp NHANH NHẤT"> </a>
            </div>
        </div>
    );
};
export default Logo;
